import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import * as actionCreators from "../../store/analytics/analytics/action-creators";
import _Aux from "../_Aux";
import ChartFilters from "./ChartFilters/ChartFilters";
import ChartWhiteboard from "./ChartWhiteboard/ChartWhiteboard";
import AlertMessage from "../Common/AlertMessage/AlertMessage";
//import Feedback from "./Feedback/Feedback";
import NavBar from "./NavBar/NavBar";

class Analytics extends React.Component {
  componentDidMount() {
    // Fetch app data (like Products) on load of the app
    this.props.onAppLoad();
  }

  componentDidUpdate(prevProps) {
    // On load of the app, simulate View Chart click with preset filters
    // to pre-render a default chart on the UI
    if (prevProps.productsLength === 0 && this.props.productsLength > 0) {
      document.getElementById("viewChartButton").click();
    }
  }

  render() {
    // Render multiple Whiteboards (used for side-by-side chart comparison)
    let chartWhiteboardsDoc = this.props.chartWhiteboards.map((whiteboard, index) => (
      <ChartWhiteboard key={whiteboard.__id} whiteboardIndex={index} whiteboard={whiteboard} />
    ));

    return (
      <_Aux>
        <AlertMessage id="globalAlertError" whichAlert="error" />
        <NavBar />
        <ChartFilters />
        {chartWhiteboardsDoc}
      </_Aux>
    );
  }
}

Analytics.propTypes = {
  chartWhiteboards: PropTypes.array.isRequired,
  productsLength: PropTypes.number.isRequired
};

const mapStateToProps = (state) => ({
  chartWhiteboards: state.analytics.chartWhiteboards,
  productsLength: state.analytics.products.length
});

const mapDispatchToProps = (dispatch) => ({
  onAppLoad: () => dispatch(actionCreators.onAppLoad({}))
});

export default connect(mapStateToProps, mapDispatchToProps)(Analytics);



// WEBPACK FOOTER //
// ./src/components/Analytics/Analytics.js